import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import App from '../App';
import {getHistory} from '../../store/history';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';

const Root = ({store}) => {
  const history = getHistory();
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop>
          <App history={history} />
        </ScrollToTop>
      </BrowserRouter>
    </Provider>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Root;
